<template>
  <div class="button" @click="changeRoute">
       <i v-if="icon" class="iconfont observer">&#xe643;</i>{{ title }}
  </div>
</template>

<script>
import {mapMutations} from "vuex";	
export default {
    props: ['title','icon','route'],
    methods: {
		...mapMutations(['setOrgIdNum']),
        //点击按钮跳转路由函数
        changeRoute() {
			this.setOrgIdNum("");
            this.$router.push(this.route);
        }
    },
	computed:{
		
	}
}
</script>

<style lang='less'>
//引入主色调样式
@import "../assets/css/mainColor.less";
    .button {
        cursor: pointer;
        position: absolute;
        z-index: 999;
        right: 10%;
        top:8.5%;
        // right: 200px;
        font-size: 22px;
        width: 150px;
        height: 50px;
        line-height: 50px;
        text-align: center;
        color: #4FCCFF;
        border: 2px solid #4FCCFF;
        .observer {
            font-size: 30px;
            vertical-align: -4px;
        }
    }
    .button::before {
        position: absolute;
        display: block;
        content: '';
        width: 0px;
        height: 50px;
        background-color: rgba(255, 255, 255,.1);
        top: 0px;
        left: 0px;
        z-index: 995;
        transition: width .5s linear;
    }
    //触摸按钮以后的阴影样式,
    .button:hover {
         box-shadow: inset 0px 0px 10px #346d6f, 0px 0px 50px rgb(3, 41, 19),
        0px 0px 20px @mainColor;
    }
    //触摸按钮的背景充能
    .button:hover::before{
        width: 150px;
        transition: width .5s linear;
    }
</style>